import React from 'react';
import Box from "./Box";

type CodeViewProps = {
    json: string
};

export const CodeView = React.forwardRef<HTMLDivElement, CodeViewProps>(function CodeView(props, ref) {
    const {
        json
    } = props

    return <Box
            forwardedRef={ref}
            {...props}
    >
       <pre>
          <code>
             {json}
          </code>
       </pre>
    </Box>;
});
